// Identitas marketplace bersama (aset resmi di /public/brand, proporsi & warna asli — lihat brand/SOURCES.md).
import { Store } from "lucide-react";
import "./marketplace_brand.css";

const B = `${process.env.PUBLIC_URL || ""}/brand`;

export function MarketplaceBrand({ channel, size = "md", label = true }) {
  if (channel === "shopee") return <span className={`mpb mpb-${size}`} data-testid="brand-shopee">
    {label ? <img className="mpb-lockup" src={`${B}/shopee-logo.svg`} alt="Shopee"/> : <img className="mpb-ico" src={`${B}/shopee-bag.png`} alt="Shopee"/>}
  </span>;
  if (channel === "tokopedia") return <span className={`mpb mpb-${size}`} data-testid="brand-tokopedia">
    <img className="mpb-ico" src={`${B}/tokopedia-icon.png`} alt={label ? "" : "Tokopedia"}/>
    {label && <img className="mpb-word" src={`${B}/tokopedia-wordmark.png`} alt="tokopedia"/>}
  </span>;
  return <span className={`mpb mpb-${size} mpb-offline`} data-testid="brand-offline"><Store className="mpb-ico-lucide" aria-hidden="true"/>{label && <span>Offline</span>}</span>;
}

// Tombol tab sumber pesanan bersama: logo di kiri tulisan, tinggi seragam, aktif = latar warna marketplace.
export function SourceTab({ channel, active, onClick, testid, count }) {
  return <button type="button" role="tab" aria-selected={active} data-ch={channel} className={`mpb-tab ${active ? "mpb-on" : ""}`}
    onClick={onClick} data-testid={testid} aria-label={channel === "offline" ? "Offline" : channel === "shopee" ? "Shopee" : "Tokopedia"}>
    <MarketplaceBrand channel={channel}/>{count > 0 && <span className="mpb-count">{count}</span>}
  </button>;
}
